import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router";
import { AppRoutes } from "@/routes/app-routes";
import { RouteProvider } from "@/providers/router-provider";
import { ThemeProvider } from "@/providers/theme-provider";
import { I18nProvider } from "@/providers/i18n-provider";
import { AccountProvider } from "@/providers/account-provider";
import { QueryProvider } from "@/providers/query-provider";
import { ToastProvider } from "@/providers/toast-provider";
import { ChatAIProvider } from "@/components/application/ai-chat/chat-ai-context";
import { AIChatDrawer } from "@/components/application/ai-chat/ai-chat-drawer";
import { AIFloatingPrompt } from "@/components/application/ai-chat/ai-floating-prompt";
import { CommandMenuProvider } from "@/components/application/command-menu/command-menu-context";
import { CommandMenuWrapper } from "@/components/application/command-menu/command-menu-wrapper";
import { AccountSwitchOverlayWrapper } from "@/components/application/app-navigation/account-switch-overlay-wrapper";
import { EnvironmentBanner } from "@/components/base/environment-banner/environment-banner";
import { SidebarProvider } from "@/providers/sidebar-provider";
import { WebSocketProvider } from "@/providers/websocket-provider";
import "@/styles/globals.css";
import "leaflet/dist/leaflet.css";
import "@xyflow/react/dist/style.css";

createRoot(document.getElementById("root")!).render(
    <StrictMode>
        <EnvironmentBanner />
        <I18nProvider>
            <ThemeProvider defaultTheme="dark">
                <QueryProvider>
                    <ToastProvider>
                        <AccountProvider>
                            <WebSocketProvider>
                                <BrowserRouter>
                                    <RouteProvider>
                                        <CommandMenuProvider>
                                            <SidebarProvider>
                                                <ChatAIProvider>
                                                <AppRoutes />
                                                {/* Global AI UI elements */}
                                                <AIChatDrawer />
                                                <AIFloatingPrompt />
                                                {/* Global Command Menu */}
                                                <CommandMenuWrapper />
                                                {/* Account Switch Overlay */}
                                                <AccountSwitchOverlayWrapper />
                                            </ChatAIProvider>
                                        </SidebarProvider>
                                    </CommandMenuProvider>
                                </RouteProvider>
                                </BrowserRouter>
                            </WebSocketProvider>
                        </AccountProvider>
                    </ToastProvider>
                </QueryProvider>
            </ThemeProvider>
        </I18nProvider>
    </StrictMode>,
);
